<template>
  <div class="time-select">
    <van-field readonly clickable name="datetimePicker" :value="propdata.text"
      @click="$emit('changeshowPicker', true)" />
    <span @click="$emit('changeshowPicker', true)">
      <slot name="prefix"></slot>
    </span>
    <van-popup v-model="propdata.showPicker" :position="propdata.position">
      <van-datetime-picker v-model="currentDate" type="year-month" :formatter="formatter" :min-date="propdata.minDate"
        :max-date="propdata.maxDate"
        @confirm="$emit('changeconfirm', { text: `${formatDate(currentDate).myyear}-${formatDate(currentDate).mymonth}`, value: `${formatDate(currentDate).myyear}-${formatDate(currentDate).mymonth}` })"
        @cancel="$emit('changeshowPicker', false)" />
    </van-popup>
  </div>
</template>

<script>
import { formatDate } from "@/utils/SetFormat";
export default {
  data() {
    return {
      formatDate,
      currentDate: ""
    };
  },
  props: {
    propdata: {
      default: () => { },
      type: Object
    }
  },
  methods: {
    formatter(type, val) {
      if (type === "year") {
        return `${val}`;
      } else if (type === "month") {
        return `${val}`;
      }
      return val;
    }
  },
  watch: {
    "propdata.showPicker": {
      handler() {
        if (this.propdata.showPicker) {
          // console.log('propdata',this.propdata);
          this.currentDate = this.propdata.value;
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.van-cell {
  padding: 0;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0);

}

.van-cell::after {
  border-bottom: none;
}

.time-select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  width: 100%;
  position: relative;
}

/deep/.van-field__body {
  height: 100%;
}

 .van-field__control {
  text-align: center!important;
  background-color: antiquewhite;
  border: 1px solid #ccc!important;
}


</style>
<style>

.time-select .van-field__control {
  text-align: center !important;
   background-color: rgb(248, 245, 242);
   /* border: 1px solid #ccc!important; */
   
}
</style>



// WEBPACK FOOTER //
// src/components/ReportLog/po-time-picker.vue